// This file was auto-generated by Fern from our API Definition.
export var SessionExecutionSnapshot;
(function (SessionExecutionSnapshot) {
    SessionExecutionSnapshot.State = {
        Idle: "idle",
        Running: "running",
        Stopping: "stopping",
    };
})(SessionExecutionSnapshot || (SessionExecutionSnapshot = {}));
